/* AppsInBundle.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppTile } from '@atlassian/mpac-app-tile';
import { Section } from '@atlassian/mpac-ui';
import { apps } from '../mocks/data';
import { TEST_ID } from './constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _9 = "._qqxt1d1o>li{flex-basis:calc(50% - 0.5rem)}";
const _8 = "._1n261g80{flex-wrap:wrap}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "._n3tdidpf{padding-bottom:0}";
const _3 = "._u5f3idpf{padding-right:0}";
const _2 = "._ca0qidpf{padding-top:0}";
const _ = "._qtt8glyw{list-style:none}";
const styles = null;
export const AppsInBundle = () => {
  return /*#__PURE__*/_jsxs(Section, {
    "data-testid": TEST_ID.OVERVIEW_TAB_RESOURCES,
    children: [/*#__PURE__*/_jsx(Section.Heading, {
      as: "h3",
      hideBorder: true,
      children: "Cloud apps included in the bundle"
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
      }), /*#__PURE__*/_jsx("ul", {
        className: ax(["_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _zulppxbi _1e0c1txw _1n261g80 _qqxt1d1o"]),
        children: apps.map((app, index) => /*#__PURE__*/_jsx(AppTile, _objectSpread(_objectSpread({}, app), {}, {
          hideTagline: true
        }), index))
      })]
    })]
  });
};